<nav class="nav navbar-dark bg-dark">
    <a class="nav-link text-white" *ngIf="sortida" [routerLink]="['/mercaderies/sortida', ('000000' + sortida.idSortida).slice(-6)]">Sortida: {{('000000' + sortida.idSortida).slice(-6)}}</a>
    <a class="nav-link text-white" *ngIf="partida" [routerLink]="['/sortida-partida', ('000000' + partida.idSortida).slice(-6), partida.idPartida]">Partida: {{('000000' + partida.idPartida).slice(-6)}}</a>
</nav>


<router-outlet *ngIf="sortida && partida"></router-outlet>
